export default "__VITE_ASSET__B8IGXehM__"